import React, { useState, useEffect, useRef } from "react";
import {
  InteractionManager,
  StatusBar,
  StyleSheet,
  TextInput,
  View,
} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import color from "@constants/color";
import analytics from "@services/analytics";
import Text from "@components/CustomText";
import { actions } from "@reducers/authReducer";
import { useDispatch } from "react-redux";
import t from "@constants/localization";
import testIds from "@constants/testIds";
import CheckBox from "@react-native-community/checkbox";
import Warning from "../../assets/svg/Warning";
import {
  SIGNUP_FLOW_EVENTS,
  SIGNUP_FLOW_SOURCES,
} from "../../constants/analyticsEventsCT";
import { sendOtpToUser } from "../../services/api";
import PrimaryButton from "../../components/PrimaryButton";
import CityMallLogoBlack from "../../assets/svg/CityMallLogoBlack";

const PATH = "screens/Auth/EnterPhone";

const EnterPhone = ({ navigation }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [nextDisabled, setNextDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checked, setChecked] = useState(false);
  const [inputBorderColor, setInputBorderColor] = useState(color.lighterBlack);
  const dispatch = useDispatch();
  const inputRef = useRef();

  const sendOtp = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    sendOtpToUser(phoneNumber, __DEV__, checked)
      .then(async (r) => {
        const { data = {} } = r || {};
        const { new_leader, phone_number = null } = data || {};
        analytics.trackEvent(SIGNUP_FLOW_EVENTS.NUMBER_ENTERED, {
          source: SIGNUP_FLOW_SOURCES.MANUALLY,
          number: phoneNumber,
        });
        const fromSignup = await AsyncStorage.getItem("newlyCreatedUser");
        if (!fromSignup) {
          AsyncStorage.setItem("isUserLoggedInFirst", "true");
        }
        dispatch(actions.setUserNumberForLogin(phone_number));
        navigation.navigate("EnterOTP", {
          phoneNumber,
          new_leader,
          checked,
        });
        setIsSubmitting(false);
      })
      .catch((e) => {
        setIsSubmitting(false);
        console.log(e);
      });
  };

  useEffect(() => {
    if (!phoneNumber) {
      setNextDisabled(true);
    }
    if (
      nextDisabled &&
      phoneNumber &&
      !Number.isNaN(parseFloat(phoneNumber)) &&
      parseFloat(phoneNumber).toString().length === 10
    ) {
      setNextDisabled(false);
    } else {
      !nextDisabled && setNextDisabled(true);
    }

    // if(var desired = stringToReplace.replace(/[^\w\s]/gi, '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneNumber]);

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      inputRef.current?.focus();
    });
  }, []);

  const formatPhoneNumber = (text) => {
    if (text && text.startsWith("+91")) {
      setPhoneNumber(text.slice(3));
    } else {
      setPhoneNumber(text);
    }
  };

  const onFocus = () => {
    setInputBorderColor("rgba(0,0,0,0.3)");
  };

  const onBlur = () => {
    setInputBorderColor(color.lighterBlack);
  };

  const onChangeNumberText = (num) => {
    formatPhoneNumber(num.replace(/[^\w\s]/gi, ""));
  };

  return (
    <>
      <StatusBar barStyle="dark-content" />
      <View style={styles.container} testID={testIds.Enter_Phone_Page}>
        <View style={styles.header}>
          <CityMallLogoBlack height={30} width={114} />
        </View>
        <View style={styles.title}>
          <Text style={styles.subTitleText}>{t(`${PATH}/getOTP`)}</Text>
        </View>
        <View style={styles.title}>
          <Text style={styles.titleText}>{t(`${PATH}/enterPhone`)}</Text>
        </View>
        <View testID={testIds.Phone_Parent} style={styles.enterPhone}>
          <Text style={styles.countryCode}>+91</Text>
          <View>
            <TextInput
              testID={testIds.Enter_Phone}
              value={phoneNumber}
              style={[styles.phoneInput, { borderColor: inputBorderColor }]}
              maxLength={10}
              keyboardType="number-pad"
              onChangeText={onChangeNumberText}
              autoCompleteType="tel"
              onFocus={onFocus}
              onBlur={onBlur}
              ref={inputRef}
            />
            {nextDisabled && phoneNumber.length > 10 && (
              <View
                style={{
                  position: "absolute",
                  top: "100%",
                  paddingVertical: 6,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Warning color={color.errorRed} />
                <Text
                  style={{
                    color: color.errorRed,
                    marginLeft: 6,
                    fontSize: 12,
                  }}
                >
                  {t(`${PATH}/checkNumber`)}
                </Text>
              </View>
            )}
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            marginHorizontal: 20,
            marginTop: 10,
            alignItems: "center",
          }}
        >
          <CheckBox
            value={checked}
            tintColors={{ true: color.primary }}
            onValueChange={setChecked}
            style={{ marginRight: 4 }}
          />
          <Text style={[styles.subTitleText, { fontSize: 14 }]}>
            {t(`${PATH}/terms`)}
          </Text>
        </View>
        <View style={{ marginHorizontal: 20, marginTop: 50 }}>
          <PrimaryButton
            testID={testIds.Enter_Phone_Move}
            loading={isSubmitting}
            disabled={nextDisabled}
            onPress={sendOtp}
            text={t(`${PATH}/goAhead`)}
            buttonStyle={{ alignSelf: "flex-start" }}
          />
        </View>
      </View>
    </>
  );
};

export default EnterPhone;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.white,
  },
  header: {
    padding: 20,
    paddingLeft: 15,
    marginBottom: 40,
  },
  title: {
    paddingHorizontal: 20,
    color: color.lightBlack,
    marginBottom: 10,
  },
  subTitleText: {
    color: color.lightBlack,
    fontSize: 16,
  },
  titleText: {
    fontSize: 24,
    fontWeight: "bold",
  },
  enterPhone: {
    position: "relative",
    flexDirection: "row",
    paddingHorizontal: 20,
  },
  countryCode: {
    borderColor: color.lighterBlack,
    borderRadius: 10,
    borderWidth: 1,
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    paddingVertical: 10,
    paddingHorizontal: 16,
    lineHeight: 24,
    marginRight: 10,
    fontSize: 16,
    alignSelf: "flex-start",
  },
  phoneInput: {
    borderColor: color.lighterBlack,
    borderRadius: 10,
    borderWidth: 1,
    paddingVertical: 8,
    paddingHorizontal: 16,
    lineHeight: 24,
    minWidth: 160,
    fontSize: 16,
  },
});
